import { useTheme } from '@mui/material';
import { SVGAttributes } from 'react';

export const EmptyIcon = (props: SVGAttributes<SVGSVGElement>) => {
  const theme = useTheme();

  const main = theme.palette.primary.main;
  const light = theme.palette.primary.light;
  const accent = theme.palette.primary.accent;

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="167"
      height="102"
      viewBox="0 0 167 102"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160 15C163.866 15 167 18.134 167 22C167 25.866 163.866 29 160 29H120C123.866 29 127 32.134 127 36C127 39.866 123.866 43 120 43H142C145.866 43 149 46.134 149 50C149 53.866 145.866 57 142 57H131.826C126.952 57 123 60.134 123 64C123 66.5773 125 68.9107 129 71C132.866 71 136 74.134 136 78C136 81.866 132.866 85 129 85H46C42.134 85 39 81.866 39 78C39 74.134 42.134 71 46 71H7C3.13401 71 0 67.866 0 64C0 60.134 3.13401 57 7 57H47C50.866 57 54 53.866 54 50C54 46.134 50.866 43 47 43H22C18.134 43 15 39.866 15 36C15 32.134 18.134 29 22 29H62C58.134 29 55 25.866 55 22C55 18.134 58.134 15 62 15H160ZM160 43C163.866 43 167 46.134 167 50C167 53.866 163.866 57 160 57C156.134 57 153 53.866 153 50C153 46.134 156.134 43 160 43Z"
        fill={light}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.672 14.0007L115.974 81.8434L116.809 88.6497C117.079 90.8424 115.519 92.8382 113.327 93.1074L54.7665 100.298C52.5739 100.567 50.5781 99.0076 50.3089 96.815L41.2931 23.3874C41.1585 22.2911 41.9381 21.2932 43.0345 21.1586C43.0414 21.1578 43.0483 21.1569 43.0553 21.1562L47.9136 20.6112"
        fill="white"
      />
      <path
        d="M106.672 14.0007L115.974 81.8434L116.809 88.6497C117.079 90.8424 115.519 92.8382 113.327 93.1074L54.7665 100.298C52.5739 100.567 50.5781 99.0076 50.3089 96.815L41.2931 23.3874C41.1585 22.2911 41.9381 21.2932 43.0345 21.1586C43.0414 21.1578 43.0483 21.1569 43.0553 21.1562L47.9136 20.6112"
        stroke={accent}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.8422 20.1715L56.4292 19.657L51.8422 20.1715Z"
        fill="white"
      />
      <path
        d="M51.8422 20.1715L56.4292 19.657"
        stroke={accent}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.14 18.2686L112.56 79.7523L113.317 85.9205C113.561 87.9077 112.167 89.714 110.203 89.9551L57.7613 96.3941C55.7978 96.6352 54.0082 95.2198 53.7642 93.2327L45.6142 26.8562C45.4795 25.7599 46.2592 24.762 47.3555 24.6274L53.8431 23.8308"
        fill={accent}
      />
      <path
        d="M63.6719 1.25H109.229C109.958 1.25 110.657 1.53933 111.173 2.05469L124.616 15.4902C125.132 16.0059 125.422 16.7053 125.422 17.4346V80C125.422 81.5188 124.191 82.75 122.672 82.75H63.6719C62.1531 82.75 60.9219 81.5188 60.9219 80V4C60.9219 2.48122 62.1531 1.25 63.6719 1.25Z"
        fill="white"
        stroke={main}
        strokeWidth="2.5"
      />
      <path
        d="M109.672 2.40234V13.9995C109.672 15.6564 111.015 16.9995 112.672 16.9995H120.605"
        stroke={main}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71 68H97M71 17H97H71ZM71 29H114H71ZM71 42H114H71ZM71 55H114H71Z"
        stroke={accent}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
